import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faInstagram} from '@fortawesome/free-brands-svg-icons'

import type {SizeProp} from '@fortawesome/fontawesome-svg-core'

interface FaInstagramProps {
  text?: string
  textIsBefore?: boolean
  showIconText?: boolean
  size?: SizeProp
}

const FaInstagram = ({
  text,
  textIsBefore = false,
  showIconText = false,
  size = 'sm',
}: FaInstagramProps) => {
  let renderDOM = (
    <span className='icon'>
      <FontAwesomeIcon icon={faInstagram} size={size} />
    </span>
  )
  if (text) {
    renderDOM = (
      <span
        className='icon-text'
        style={{flexWrap: 'nowrap'}}
      >
        {textIsBefore && showIconText && <span>{text}</span>}
        <span className='icon'>
          <FontAwesomeIcon icon={faInstagram} size={size} />
        </span>
        {!textIsBefore && showIconText && <span>{text}</span>}
      </span>
    )
  }
  return renderDOM
}

export default FaInstagram
